const initialState = {
  currentAddress: {
    flatStreet: '',
    landmark: '',
    pincode: '',
    city: '',
    state: '',
  },
  permanentAddress: {
    flatStreet: '',
    landmark: '',
    pincode: '',
    city: '',
    state: '',
  },
}

const addressReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_CURRENT_ADDRESS':
      return {
        ...state,
        currentAddress: action.payload,
      }
    case 'UPDATE_PERMANENT_ADDRESS':
      return {
        ...state,
        permanentAddress: action.payload,
      }
    default:
      return state
  }
}
export default addressReducer
